import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TipoPagamentoEditarComponent } from "./tipo-pagamento-editar.component";
import { TipoPagamentoEditarRoutingModule } from "./tipo-pagamento-editar-routing.module";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';
import {CheckboxModule} from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from "primeng/inputnumber";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { ProgressSpinnerModule } from "primeng/progressspinner";



@NgModule({
    imports: [
        CommonModule,            
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        InputTextareaModule,
        TipoPagamentoEditarRoutingModule,
        InputMaskModule,
        MessagesModule,
        TableModule,
        InputSwitchModule,
        CheckboxModule,
        CalendarModule,
        InputNumberModule,
        ConfirmDialogModule,
        ProgressSpinnerModule

    ],
    declarations: [TipoPagamentoEditarComponent],
    providers: [ConfirmationService]
})
export class TipoPagamentoEditarModule { }
